// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__b4V94","paramInput":"JobSimulator_paramInput__2LZR0","input":"JobSimulator_input__3ce7y"};